// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__SNRl4","Label":"Input_Label__3w96u","InputElement":"Input_InputElement__pO52w","Invalid":"Input_Invalid__3aeyU","Error":"Input_Error__NCFY0"};